export const SELECT_SONG = 'SELECT_SONG';
export const GET_UPOLOADED_SONGS = 'GET_UPOLOADED_SONGS';
export const CHANGE_SONG_STATUS = 'CHANGE_SONG_STATUS';